import { render, staticRenderFns } from "./teachingBehaviorAnalysis.vue?vue&type=template&id=3812a1a6&scoped=true"
import script from "./teachingBehaviorAnalysis.vue?vue&type=script&lang=js"
export * from "./teachingBehaviorAnalysis.vue?vue&type=script&lang=js"
import style0 from "./teachingBehaviorAnalysis.vue?vue&type=style&index=0&id=3812a1a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812a1a6",
  null
  
)

export default component.exports